import i18n from '@/i18n'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, data, vm, titleData) => {
  try {
    // Translation
    if (i18n.locale === 'bn') {
      pdfMake.vfs = pdfFontsBn.pdfMake.vfs
    } else {
        pdfMake.vfs = pdfFontsEn.pdfMake.vfs
    }

    // API Call
    const reportHeading = await ReportHeading.getReportHead(baseUrl, uri, orgId)

    // PDF
    const pdfContent = []

    //
    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: ['25%', '50%', '25%'],
          body: [
            [
              { image: reportHeading.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
              { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
              { image: reportHeading.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
            ],
            [
              {},
              { text: vm.$t('social_service.dss'), style: 'header2', alignment: 'center' },
              {}
            ],
            [
              {},
              {},
              {}
            ],
            [
              {},
              { text: reportHeading.address, style: 'address', alignment: 'center' },
              {}
            ],
            [
              {},
              { text: reportTitle, style: 'address2', alignment: 'center' },
              {}
            ]
          ]
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0
          },
          vLineWidth: function (i, node) {
            return 0
          }
        }
      }
    )

    //
    pdfContent.push(
      {
        table: {
          style: 'tableData',
          headerRows: 0,
          widths: ['50%', '50%'],
          body: [
            [
              { text: vm.$t('report_monthly.workplace_name') + ' : ' + (titleData.workplace_name ? titleData.workplace_name : ''), style: 'th', alignment: 'left' },
              {}
            ],
            [
              { text: vm.$t('social_service.fisyear') + ' : ' + vm.search_report.fisYear, style: 'th', alignment: 'left' },
              {}
            ]
          ]
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0
          },
          vLineWidth: function (i, node) {
            return 0
          }
        }
      }
    )

    //
    pdfContent.push(
      { text: '', style: 'empty_space' }
    )

    // i
    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
          body: [
            // 1
            [
              { text: vm.$t('report.year_fin_prev_month'), colSpan: 4, style: 'th', alignment: 'center' },
              {},
              {},
              {},
              { text: vm.$t('report.year_fin_inc'), colSpan: 3, style: 'th', alignment: 'center' },
              {},
              {},
              { text: vm.$t('report.tot_cash_depo'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report.year_fin_heaved'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report.year_fin_tot_cash_expenses'), rowSpan: 2, style: 'th', alignment: 'center' }
            ],
            // 2
            [
              { text: vm.$t('report_monthly.cash_hand'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.bank_dep'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.fdr'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.year_fin_total_cash') + ' ' + vm.$t('report.year_fin_surplus13'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.year_fin_govt'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.year_fin_private'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.tot_cash_inc'), style: 'th', alignment: 'center' },
              {},
              {},
              {}
            ],
            // 3
            [
              { text: vm.$n(1), style: 'th', alignment: 'center' },
              { text: vm.$n(2), style: 'th', alignment: 'center' },
              { text: vm.$n(3), style: 'th', alignment: 'center' },
              { text: vm.$n(4), style: 'th', alignment: 'center' },
              { text: vm.$n(5), style: 'th', alignment: 'center' },
              { text: vm.$n(6), style: 'th', alignment: 'center' },
              { text: vm.$n(7), style: 'th', alignment: 'center' },
              { text: vm.$n(8), style: 'th', alignment: 'center' },
              { text: vm.$n(9), style: 'th', alignment: 'center' },
              { text: vm.$n(10), style: 'th', alignment: 'center' }
            ],
            [
              { text: vm.$n(data.cash_hand), style: 'th', alignment: 'center' },
              { text: vm.$n(data.bank_dep), style: 'th', alignment: 'center' },
              { text: vm.$n(data.fdr), style: 'th', alignment: 'center' },
              { text: vm.$n(data.cash_hand + data.fdr), style: 'th', alignment: 'center' },
              { text: vm.$n(data.year_fin_govt), style: 'th', alignment: 'center' },
              { text: vm.$n(data.year_fin_private), style: 'th', alignment: 'center' },
              { text: vm.$n(data.year_fin_govt + data.year_fin_private), style: 'th', alignment: 'center' },
              { text: vm.$n(data.cash_hand + data.fdr + data.year_fin_govt + data.year_fin_private), style: 'th', alignment: 'center' },
              { text: vm.$n(data.year_fin_heaved), style: 'th', alignment: 'center' },
              { text: vm.$n(data.year_fin_tot_cash_expenses), style: 'th', alignment: 'center' }
            ]
          ]
        }
      }
    )

    //
    pdfContent.push(
      { text: '', style: 'empty_space' }
    )

    // ii
    pdfContent.push(
      {
        table: {
          headerRows: 0,
          widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
          body: [
            // 1
            [
              { text: vm.$t('report.year_fin_status'), colSpan: 4, style: 'th', alignment: 'center' },
              {},
              {},
              {},
              { text: vm.$t('report.year_fin_dir_dona'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report.year_fin_inc_sav'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report.year_fin_tot_depo'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report.year_fin_tot_expense'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('report.year_fin_tot_exp'), rowSpan: 2, style: 'th', alignment: 'center' },
              { text: vm.$t('social_service.comment'), rowSpan: 2, style: 'th', alignment: 'center' }
            ],
            [
              { text: vm.$t('report_monthly.cash_hand'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.bank_dep'), style: 'th', alignment: 'center' },
              { text: vm.$t('report_monthly.fdr'), style: 'th', alignment: 'center' },
              { text: vm.$t('report.year_fin_total_cash') + ' ' + vm.$t('report.year_fin_surplus1113'), style: 'th', alignment: 'center' },
              {},
              {},
              {},
              {},
              {},
              {}
            ],
            // 3
            [
              { text: vm.$n(11), style: 'th', alignment: 'center' },
              { text: vm.$n(12), style: 'th', alignment: 'center' },
              { text: vm.$n(13), style: 'th', alignment: 'center' },
              { text: vm.$n(14), style: 'th', alignment: 'center' },
              { text: vm.$n(15), style: 'th', alignment: 'center' },
              { text: vm.$n(16), style: 'th', alignment: 'center' },
              { text: vm.$n(17), style: 'th', alignment: 'center' },
              { text: vm.$n(18), style: 'th', alignment: 'center' },
              { text: vm.$n(19), style: 'th', alignment: 'center' },
              { text: vm.$n(20), style: 'th', alignment: 'center' }
            ],
            // 4
            [
              { text: vm.$n(data.cash_hand2), style: 'th', alignment: 'center' },
              { text: vm.$n(data.bank_dep2), style: 'th', alignment: 'center' },
              { text: vm.$n(data.fdr2), style: 'th', alignment: 'center' },
              { text: vm.$n(data.cash_hand2 + data.fdr2), style: 'th', alignment: 'center' },
              { text: vm.$n(data.year_fin_dir_dona), style: 'th', alignment: 'center' },
              { text: vm.$n(data.year_fin_inc_sav), style: 'th', alignment: 'center' },
              { text: vm.$n(data.year_fin_dir_dona + data.year_fin_inc_sav), style: 'th', alignment: 'center' },
              { text: vm.$n(data.year_fin_tot_expense), style: 'th', alignment: 'center' },
              { text: vm.$n(data.year_fin_tot_exp), style: 'th', alignment: 'center' },
              { text: (data.comment), style: 'th', alignment: 'center' }
            ]
          ]
        }
      }
    )

    var docDefinition = {
      content: pdfContent,
      pageSize: 'A4',
      pageOrientation: 'landscape',
      styles: {
          th: {
            fontSize: 10,
            margin: [3, 3, 3, 3],
            bold: true
          },
          td: {
            fontSize: 8,
            margin: [3, 3, 3, 3]
          },
          header: {
            margin: [0, 1, 0, 15],
            fontSize: 16,
            alignment: 'center'
          },
          header2: {
            border: 0,
            fontSize: 14,
            margin: [0, 0, 0, 1]
          },
          govt_info: {
            margin: [0, 1, 0, 1],
            fontSize: 18,
            alignment: 'center'
          },
          address2: {
            border: 0,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5]
          },
          empty_space: {
            margin: [10, 10, 10, 10]
          }
      }
    }

    pdfMake.createPdf(docDefinition, null, null, null).print()
  } catch (error) {
    if (error) {
      //
    }
  }
}

export default {
  exportPdfDetails
}
